import React from "react";
import { useTranslation } from "react-i18next";
import {
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
  Typography,
} from "@mui/material";
import { Theme } from "@mui/material/styles";
import { MyAllEventIcon } from "@/assets";
import NavLink from "../NavLink/NavLink";

const MyEventsMenu = () => {
  const { t } = useTranslation(["translation.navigation"]);

  return (
    <>
      <MenuList
        sx={{
          "& .MuiMenuItem-root": {
            minHeight: "40px !important",
            alignItems: "center",
            color: (theme) => theme?.palette?.primary?.light,
            "&:hover": {
              backgroundColor: (theme: Theme) => theme.palette.secondary.light,
            },
            "&.Mui-selected": {
              backgroundColor: (theme: Theme) =>
                theme?.palette?.secondary?.dark,
            },
          },
          "& .MuiListItemIcon-root": {
            minWidth: "auto !important",
            color: (theme) => theme?.palette?.primary?.light,
          },
          "& .MuiListItemText-root": {
            ".MuiTypography-root": {
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          },
        }}
      >
        <MenuItem
          component={NavLink}
          to="/events"
          end
          sx={{ p: (theme: Theme) => theme?.spacing(0, 2, 0, 1) }}
        >
          <ListItemIcon sx={{ px: 1 }}>
            <MyAllEventIcon />
          </ListItemIcon>
          <ListItemText>
            <Typography variant="h5">{t("AllMyEvents")}</Typography>
          </ListItemText>
        </MenuItem>
      </MenuList>
    </>
  );
};

export default React.memo(MyEventsMenu);
